/**
 * Gọi / nhắn SAPA ở mọi lúc (đợt 3 · 3.2): một khối dùng ở menu tài khoản, màn lỗi (`RaoLoi`) và Gói SAPA.
 * Số lấy từ `/v1/public/ho-tro`, thiếu thì `SDT_HO_TRO` (xem `ho-tro-sapa.ts`). Nút ≥ 48px, chữ ≥ 16px.
 */
import { MessageCircle, Phone } from 'lucide-react'
import { useEffect, useState } from 'react'
import { auth, type HoTro } from './api.ts'
import { chonLienHeSapa, type LienHeSapa } from './ho-tro-sapa.ts'
import { T } from './text/vi.ts'

/** Giữ kết quả cho cả phiên của trang: số hỗ trợ không đổi giữa chừng, khỏi hỏi lại ở mỗi chỗ hiện. */
let daBiet: HoTro | null = null

/** Số hiện tại để dùng NGAY (không chờ mạng); cập nhật khi máy chủ trả lời. Lỗi → giữ số dự phòng. */
export function useLienHeSapa(): LienHeSapa {
  const [h, setH] = useState<HoTro | null>(daBiet)
  useEffect(() => {
    if (daBiet !== null) return
    let dung = false
    auth
      .hoTro()
      .then((x) => {
        daBiet = x
        if (!dung) setH(x)
      })
      .catch(() => undefined)
    return () => {
      dung = true
    }
  }, [])
  return chonLienHeSapa(h)
}

/**
 * - `menu`: hai nút đầy bề ngang, số nằm ngay trong nút "Gọi SAPA".
 * - `cau`: câu "Cần giúp? Gọi SAPA: {số}" là một nút gọi, kèm nút nhắn Zalo (màn lỗi, Gói SAPA).
 */
export function LienHeSapaKhoi({ kieu }: { kieu: 'menu' | 'cau' }) {
  const lh = useLienHeSapa()
  return (
    <div className={`lien-he-sapa lien-he-${kieu}`}>
      <a className="nut nut-vien nut-lon nut-rong" href={lh.goi}>
        <Phone size={20} />
        {kieu === 'menu' ? (
          <span className="chu-goi">
            <span>{T.goiSapa}</span>
            <b>{lh.hien}</b>
          </span>
        ) : (
          // Dấu cách cứng trong số: xuống dòng thì cả số sang dòng mới, không tách "0987 939 / 605".
          T.canGiup(lh.hien.replace(/ /g, '\u00a0'))
        )}
      </a>
      <a className="nut nut-vien nut-lon nut-rong" href={lh.zalo} target="_blank" rel="noreferrer">
        <MessageCircle size={20} />
        {T.nhanZaloSapa}
      </a>
    </div>
  )
}
